import 'regenerator-runtime/runtime'
import amazingScroll from './modules/amazingScroll'
import amazingScrollSlider from './modules/amazingScrollSlider'
import magnificPopupTranslation from './modules/magnificPopupTranslation'
import scrollToElement from './modules/scrollToElement'
import numberCounter from './modules/counter'
import fixedNavbar from './modules/fixedNavbar'
// import imageSlider from './modules/imageSlider'

var animationList = {
	'fade-bottom': 'bottom:-100px->0; transition:all 1s; opacity:0->1;',
	'enlarge': 'transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s',
	'shrink': 'transform:scale(1)->scale(0.5); opacity: 0->1; transition:all 0s->all 1s',
	'fade-left': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s',
	'fade-left-2': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.2s',
	'fade-left-4': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.4s',
	'fade-left-6': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.6s',
	'fade-left-8': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.8s',
	'fade-left-10': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 1s',
	'fade-left-12': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 1.2s',
	'fade-left-14': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 1.4s',
	'fade-left-16': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 1.6s',
	'fade-right': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s',
	'fade-right-2': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.2s',
	'fade-right-4': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.4s',
	'fade-right-6': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.6s',
	'fade-left-top': 'opacity: 0->1; left:-50px->0; top:-50px->0; transition:alls 0s->all 1s',
	'fade-left-bottom': 'opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1s',
	'opacity': 'opacity: 0->1; transition:all 0s->all 1s',
	'opacity-2': 'opacity: 0->1; transition:all 0s->all 1s 0.2s',
	'opacity-4': 'opacity: 0->1; transition:all 0s->all 1s 0.4s',
	'opacity-6': 'opacity: 0->1; transition:all 0s->all 1s 0.6s',
	'rotate': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s',
	'rotate-2': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.2s',
	'rotate-4': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.4s',
	'rotate-6': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.6s',
	'fade-top': 'top:-100px->0; transition:all 0s->all 1s; opacity:0->1;',
	'fade-top-0': 'top:-100px->0; transition:all 0s->all 1s; opacity:0->1;',
	'fade-top-2': 'top:-100px->0; transition:all 0s->all 1s 0.2s; opacity:0->1;',
	'fade-top-4': 'top:-100px->0; transition:all 0s->all 1s 0.4s; opacity:0->1;',
	'fade-top-6': 'top:-100px->0; transition:all 0s->all 1s 0.6s; opacity:0->1;'
}

const goToTop = document.querySelector('#go-to-top')
const openButton = document.querySelector('#open')
document.addEventListener('DOMContentLoaded', function () {
	const openButton = document.querySelector('#open')
	const closeButton = document.querySelector('#close')
	const telephoneModalForm = $('#telephoneModal')
	const goToTop = document.querySelector('#go-to-top')

	if (openButton) {
		openButton.addEventListener('click', function () {
			telephoneModalForm.modal('show')
		})
	}

	if (closeButton) {
		closeButton.addEventListener('click', function () {
			telephoneModalForm.modal('hide')
		})
	}

	window.addEventListener('scroll', function () {
		if (window.scrollY >= 3100) {
			openButton.style.bottom = '8rem'
		}

		if (window.scrollY <= 3100) {
			openButton.style.bottom = '2rem'
		}
	})

	if (window.innerWidth >= 1200) {
		window.animate = amazingScroll({
			start: {
				visibleAfterLoading: true,
				waitForScroll: {
					on: false,
					ratio: 0
				}
			},
			animation: animationList
		})
	}

	const selectors = ['.slidersukcesu']
	selectors.forEach(selector => {
		if(!document.querySelector(selector)) return
		amazingScrollSlider(selector, animationList)
		// jQuery(selector).carousel({
		// 	pause: false
		// })
	})

	magnificPopupTranslation()
	scrollToElement(120)
	numberCounter()

	fixedNavbar()
})




// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js